import React from 'react';
// import "../../assets/css/master.css";

import TemplateDashboard from "../../../components/TemplateDashboard";
import GruposDetalleContent from './components/GruposDetalleContent';

const GruposDetalle = () => {

    return (
        <>

            <TemplateDashboard>
                <GruposDetalleContent />
            </TemplateDashboard>

        </>
    )
};

export default GruposDetalle;